<template>
  <div>
    <Head title="បង្កើតបុគ្គលិក" />
    <h1 class="moul flex items-center mb-8 text-2xl">
      <Link class="flex items-center text-indigo-400 hover:text-indigo-600" href="/users"><UsersIcon class="mr-2 w-8 h-8" /> បុគ្គលិក</Link>
      <span class="text-indigo-400 font-medium"><ChevronRightIcon class="w-5 h-5" /></span> បង្កើតថ្មី
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.first_name" :error="form.errors.first_name" class="pb-8 pr-6 w-full lg:w-1/2" label="គោត្តនាម *" />
          <text-input v-model="form.last_name" :error="form.errors.last_name" class="pb-8 pr-6 w-full lg:w-1/2" label="នាមខ្លួន *" />
          <text-input v-model="form.phone" :error="form.errors.phone" class="pb-8 pr-6 w-full lg:w-1/2" label="លេខទូរសព្ទ" />
          <!-- <text-input v-model="form.email" :error="form.errors.email" class="pb-8 pr-6 w-full lg:w-1/2" label="អ៊ីមែល *" /> -->
          <select-input v-model="form.owner" :error="form.errors.owner" class="pb-8 pr-6 w-full lg:w-1/2" label="តួនាទី">
            <option :value="true">អ្នកគ្រប់គ្រង</option>
            <option :value="false">មន្ត្រីឥណទាន</option>
          </select-input>
          <div class="w-full mb-4">
            <hr />
          </div>
          <text-input v-model="form.password" :error="form.errors.password" class="pb-8 pr-6 w-full lg:w-1/2" type="password" autocomplete="new-password" label="លេខសម្ងាត់ *" />
          <!-- <file-input v-model="form.photo" :error="form.errors.photo" class="pb-8 pr-6 w-full lg:w-1/2" type="file" accept="image/*" label="រូបភាព" /> -->
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">បង្កើតឥឡូវនេះ</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import { UsersIcon, ChevronRightIcon } from '@heroicons/vue/24/outline'

export default {
  components: {
    FileInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    UsersIcon,
    ChevronRightIcon,
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        first_name: '',
        last_name: '',
        phone: '',
        email: '',
        password: '',
        owner: false,
        photo: null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/users')
    },
  },
}
</script>
